import {ActivatedRouteSnapshot} from "@angular/router";

export const constructPathFromRoute = (route: ActivatedRouteSnapshot): string => {
    let result;
    let current = route;
    while (current && current.routeConfig) {
        result = result ? (current.routeConfig.path ? `${current.routeConfig.path}/${result}` : `${result}`) : `${current.routeConfig.path}`;
        current = current.parent;
    }

    return result ? `/${result}` : null;
};

// Splits the URL into segments by "/" sign and replaces last segment with new value
// Example:
// ("app/test/update/OLD_ID?testParam=1234", "NEW_ID", true)
// Returns "app/test/update/NEW_ID?testParam=1234"
export const replaceLastPathSegment = (path: string, newValue: string, keepParams: boolean = true) => {
    const [urlPath, ...queryParts] = path.split("?");
    const segments = urlPath.split("/").filter(x => !!x);

    if (segments.length === 0) {
        return path;
    }

    segments[segments.length - 1] = newValue;
    const newPath = segments.join("/");

    if (keepParams && queryParts.length > 0) {
        return `${newPath}?${queryParts.join("?")}`;
    }

    return newPath;
}

export const removePathParam = (path: string, paramName: string) => {
    const [urlPath, ...queryParts] = path.split("?");
    if (queryParts.length === 0) {
        return path;
    }

    const queryString = queryParts.join("?");
    const params = new URLSearchParams(queryString);
    params.delete(paramName);

    const newQueryString = params.toString();
    return newQueryString ? `${urlPath}?${newQueryString}` : urlPath;
}
